import React, { useMemo } from 'react';
import { HistoryProvider } from '@tanium/react-history-context';
import { HashRouter } from 'react-router-dom';
import { EmotionProvider as EmotionThemeProvider } from '@tanium/react-emotion';
import { ThemeProvider as TaniumThemeProvider } from '@tanium/react-theme-context';
import { bluestar } from '@tanium/theme-data';
import { createHashHistory } from 'history';
import '../../i18n';
import { AppContainer } from '../AppContainer/AppContainer';
import { newLoginProvider } from '../../auth/broker';

export const App: React.VFC = () => {
  const history = useMemo(() => createHashHistory(), []);
  // Chosen once per mount rather than at import, so the provider tracks the URL
  // this page actually loaded with.
  const authProvider = useMemo(newLoginProvider, []);

  return (
    <EmotionThemeProvider theme={bluestar}>
      <TaniumThemeProvider theme={bluestar}>
        <HashRouter>
          <HistoryProvider history={history}>
            <AppContainer authProvider={authProvider} />
          </HistoryProvider>
        </HashRouter>
      </TaniumThemeProvider>
    </EmotionThemeProvider>
  );
};
